export enum PRICE_TYPES {
  STANDARD = "standard",
  PREMIUM = "premium",
}
